import authCover from "../../assets/img/auth/authCover.jpg";

export default function AuthLayout({className, ...props}) {

    return (
        <div className={"w-full h-full flex"}>
            <div className={"flex-1 hidden lg:flex bg-cover bg-center"}
                 style={{backgroundImage: `url(${authCover})`}}
            >

            </div>
            <div className={"flex-1 flex p-8   justify-center  pt-[4vh] lg:pt-8 lg:items-center"}>
                {
                    props.children

                }
            </div>


        </div>

    )
}